export default __webpack_public_path__ + "static/media/Gallery6.7796e644.jpg";